import script from "./HrEmployeeDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrEmployeeDetails.vue?vue&type=script&lang=ts&setup=true"

import "./HrEmployeeDetails.vue?vue&type=style&index=0&id=483cd7b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-483cd7b2"]])

export default __exports__